import React from "react";
import { Box, Divider, Typography } from "@mui/material";
import paypalcard from "../../../../assets/Wallet/paypalcard.png";
import stripecard from "../../../../assets/Wallet/stripecard.png"
import CustomText, { textStyles } from "../../../../components/CustomText";
import { useTranslation } from "react-i18next";
const PaymentMethodCard = () => {
  const { t } = useTranslation();
  return (
        <Box sx={{ backgroundColor: '#fff', borderRadius: 2, py: 3,px:3, border: '1px solid #E4E6EF' }}>
     
        <CustomText sx={{ ...textStyles.h1, fontSize: 20, fontWeight: 600, color: '#2C384C', textAlign: 'left', pb: 1 }}>
                 {t('paymentMethodCard.heading')}
              </CustomText>
  
           <CustomText sx={{ ...textStyles.body6,  fontSize:16, lineHeight:"20px",pt:1,fontWeight: 500, color: '#5A5A5A', textAlign: 'left', pb: 1 }}>
                 {t('paymentMethodCard.subheading')}
              </CustomText>

      {/* Paypal Section */}
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2,mt:3, }}>
        <Box sx={{ width: 50, mr: 2 }}>
          <img src={paypalcard} alt="Paypal" style={{ width: '100%',height:"100%" }} />
        </Box>
        <Box>
      
          <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 600, color: '#2C384C', textAlign: 'left', pb: 1 }}>
            {t('paymentMethodCard.paypal_title')}
              </CustomText>
      
  
              <CustomText sx={{ ...textStyles.body6,  fontSize:16, lineHeight:"20px",pt:1,fontWeight: 500, color: '#5A5A5A', textAlign: 'left', pb: 1 }}>
  {t('paymentMethodCard.paypal_info').split('\n').map((line, i) => (
    <React.Fragment key={i}>
      {line}
      <br />
    </React.Fragment>
  ))}
</CustomText>
        </Box>
      </Box>

  
    </Box>
  );
};

export default PaymentMethodCard;
